
import { defineComponent, ref, watch, computed, PropType } from 'vue';
import { _CreatedNotice } from '../../composable/useContentInfo';
import { NOTICE_SYSTEM_LIST, ONLINE_SYSTEM_LIST } from '../../constant/index';
import type { INoticeEditReq } from '@/api/content-manage/type.d';

export default defineComponent({
  name: 'CreatedNotice',
  emits: ['update:visible', 'handleSearch'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    noticeItem: {
      type: Object as PropType<INoticeEditReq>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const selfVisible = computed({
      get() {
        return props.visible;
      },
      set(val: boolean) {
        emit('update:visible', val);
      },
    });

    const formData = ref<Partial<INoticeEditReq>>({
      noticeId: '', // 通知id
      noticeCode: '', // 通知编码
      updateSystem: [], // 更新系统
      noticeSystem: [], // 通知系统
      theme: '', // 通知栏
      content: '', // 具体更新内容
      publishTime: '', // 开始通知时间
      publishEndTime: '', // 结束通知时间
    });

    /**
     * 选择更新系统时，触发通知响应的系统
     * @param val
     */
    const selectOnlineChange = (val:string[]) => {
      val.forEach((item) => {
        if (formData.value.noticeSystem?.indexOf(item) === -1) {
          formData.value.noticeSystem.push(item);
        }
      });
    };
    const handleNoticeSystemRemove = (val:any) => {
      if (formData.value.updateSystem?.indexOf(val) !== -1) {
        const filter = (item: any) => {
          return val !== item && typeof item !== 'undefined';
        };
        formData.value.updateSystem = formData.value.updateSystem?.filter(filter);
      }
    };
    const handleOnlineChangeRemove = (val:any) => {
      const filter = (item: any) => {
        return val !== item && typeof item !== 'undefined';
      };
      formData.value.noticeSystem = formData.value.noticeSystem?.filter(filter);
    };
    // 校验通知系统
    const handleSelect = (rule: any, value: string, callback: any) => {
      formData.value.updateSystem?.forEach((item) => {
        if (formData.value.noticeSystem && !formData.value.noticeSystem?.includes(item)) {
          callback(new Error('通知系统必须包含更新系统类别'));
        }
      });
      callback();
    };

    const {
      handleSave,
      handleClose,
      handleDictValues,
      dictValues,
    } = _CreatedNotice(
      formData,
      emit as any,
    );

    // 通知时间范围限制
    const disabledDate = (time:Date) => {
      return (time.getTime() + 3600 * 1000 * 24) < Date.now();
    };

    watch(props, (val) => {
      if (val.visible && props.noticeItem.noticeId) {
        formData.value = props.noticeItem;
        // formData.value.updateSystem = formData.value.updateSystem?.toString().split(',') as any;
        // formData.value.noticeSystem = formData.value.noticeSystem?.toString().split(',') as any;
      } else {
        formData.value = Object.assign({}, {
          noticeId: '', // 通知id
          noticeCode: '', // 通知编码
          updateSystem: [], // 更新系统
          noticeSystem: [], // 通知系统
          theme: '', // 通知栏
          content: '', // 具体更新内容
          publishTime: '', // 开始通知时间
          publishEndTime: '', // 结束通知时间
        });
      }
    });
    const rules = ref({
      updateSystem: [{ required: true, message: '请选择需更新系统', trigger: 'blur' }],
      noticeSystem: [
        { required: true, message: '请选择需通知系统', trigger: 'blur' },
        { required: true, validator: handleSelect, trigger: 'change' },
      ],
      theme: [{ required: true, message: '请输入通知栏', trigger: 'blur' }],
      publishTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
      publishEndTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
      content: [{ required: true, message: '请输入通知内容', trigger: 'blur' }],
    });

    return {
      selfVisible,
      formData,
      rules,
      disabledDate,
      handleSave,
      handleClose,
      selectOnlineChange,
      NOTICE_SYSTEM_LIST,
      ONLINE_SYSTEM_LIST,
      handleNoticeSystemRemove,
      handleDictValues,
      dictValues,
      handleOnlineChangeRemove,
    };
  },
});
